import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { DeletionRequestsData } from '@recruitee/http/types';

@Injectable({ providedIn: 'root' })
export class DeletionRequestsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchDeletionRequests(): Observable<DeletionRequestsData> {
    return this.httpApi.get('/deletion_requests', {}, { skipCompany: true });
  }
}
